export const RESET_VUEX_SYSTEM_ROLES = "RESET_VUEX_SYSTEM_ROLES";
export const GET_ALL_ROLES = "GET_ALL_ROLES";
export const GET_SPECIFIC_ROLE = "GET_SPECIFIC_ROLE";
export const SET_SELECTED_ROLES = "SET_SELECTED_ROLES";

export const GET_RAMAIS = "GET_RAMAIS";
export const SET_SELECTED_RAMAIS_RELATORIO_PABX =
  "SET_SELECTED_RAMAIS_RELATORIO_PABX";
export const SET_SELECTED_RAMAIS_MONITOR_RAMAIS =
  "SET_SELECTED_RAMAIS_MONITOR_RAMAIS";

export const GET_TAGS = "GET_TAGS";
export const SET_SELECTED_TAGS_RELATORIO_PABX =
  "SET_SELECTED_TAGS_RELATORIO_PABX";
export const SET_SELECTED_TAGS_PESQUISA_SATISFACAO =
  "SET_SELECTED_TAGS_PESQUISA_SATISFACAO";

export const GET_CONFERENCIAS = "GET_CONFERENCIAS";
export const SET_SELECTED_CONFERENCIAS = "SET_SELECTED_CONFERENCIAS";

export const GET_OPERADORES = "GET_OPERADORES";
export const SET_SELECTED_OPERADORES = "SET_SELECTED_OPERADORES";

export const GET_FILAS = "GET_FILAS";
export const SET_SELECTED_FILAS = "SET_SELECTED_FILAS";

export const GET_DEPARTAMENTOS = "GET_DEPARTAMENTOS";
export const SET_SELECTED_DEPARTAMENTOS = "SET_SELECTED_DEPARTAMENTOS";

export const GET_PESQUISAS_SATISFACAO = "GET_PESQUISAS_SATISFACAO";
export const SET_SELECTED_PESQUISAS_SATISFACAO =
  "SET_SELECTED_PESQUISAS_SATISFACAO";

//========

export const ADD_PERMISSION_ID = "ADD_PERMISSION_ID";
export const DELETE_PERMISSION_ID = "DELETE_PERMISSION_ID";
export const CHANGE_ALL_PERMISSION_ID = "CHANGE_ALL_PERMISSION_ID";
